import {
  Commune,
  CommuneCreateCommand,
  CommuneCreatedEvent,
  CommuneDeleteCommand,
  CommuneDeletedEvent,
  CommuneId,
  CommunePageQuery,
  CommuneUpdateCommand,
  CommuneUpdatedEvent
} from "../model/Commune";
import {config} from "../../../config";
import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {firstPage, PageQuery, PageResult, toPagination} from "@tracabois/utils";
import {useState} from "react";
import {authQuery} from "../../../utils/authQuery";

export const CommuneApi = createApi({
  reducerPath: 'communeApi',
  baseQuery: authQuery({baseUrl: config.baseUrl}),
  tagTypes: ['Commune'],
  endpoints: (builder) => ({
    getCommuneById: builder.query<Commune, CommuneId>({
      query: (id: CommuneId) => ({
        url: `communeGet`,
        method: 'POST',
        body: {id: id}
      }),
    }),
    communePage: builder.query<PageResult<Commune>, CommunePageQuery>({
      query: (page: CommunePageQuery) => ({
        url: `communePage`,
        method: 'POST',
        body: page
      }),
      transformResponse: (response: PageResult<Commune>[]) => response[0],
      providesTags: ['Commune'],
    }),
    communeCreate: builder.mutation<CommuneCreatedEvent, CommuneCreateCommand>({
      query: (cmd: CommuneCreateCommand) => ({
        url: `communeCreate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: CommuneCreatedEvent[]) => response[0],
      invalidatesTags: ['Commune'],
    }),
    communeUpdate: builder.mutation<CommuneUpdatedEvent, CommuneUpdateCommand>({
      query: (cmd: CommuneUpdateCommand) => ({
        url: `communeUpdate`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: CommuneUpdatedEvent[]) => response[0],
      invalidatesTags: ['Commune'],
    }),
    communeDelete: builder.mutation<CommuneDeletedEvent, CommuneDeleteCommand>({
      query: (cmd: CommuneDeleteCommand) => ({
        url: `communeDelete`,
        method: 'POST',
        body: cmd
      }),
      transformResponse: (response: CommuneDeletedEvent[]) => response[0],
      invalidatesTags: ['Commune'],
    }),
  }),
})

export const {
  useGetCommuneByIdQuery, useCommunePageQuery,
  useCommuneCreateMutation, useCommuneUpdateMutation, useCommuneDeleteMutation
} = CommuneApi

export const useCommuneAllQuery = () => {
  const {data, error, isLoading, refetch} = CommuneApi.useCommunePageQuery({})
  const [pageQuery, setPageQuery] = useState<PageQuery>({
    pagination: firstPage
  })
  let sortedData =  [...data?.items ?? []]
  if(pageQuery.search) {
    sortedData = sortedData.filter((item) => {
      return item.name.toLowerCase().includes(pageQuery.search?.toLowerCase() ?? "")
    })
  }
  const page = toPagination(sortedData, pageQuery.pagination)

  return {data: page, error, isLoading, refetch, setPageQuery}
}
